import React, { useEffect } from "react";
import { useRoles } from "../../../application/roles/hooks/useRoles";
import "./style.css"
import Page from "../../ui/page";
import NavigationService from "../../../utils/history";
import PermissionManager from "../../ui/PermissionManager";
import Input from "../../ui/input";
import { Row, Col } from '../../ui/grid'
import { PrimaryButton } from "../../ui/button";
import { ModalConfirm } from '../../ui/modal2'
import ToolbarComponent from "../../ui/section";

const NewRoleView = (props) => {
    const {
        modulesRole,
        rolPermissions,
        handlePermissionsChange,
        handleSave,
        rolName,
        setRolName,
        confirmCreate,
        setConfirmCreate,
        edit,
        goBack,
        getById,
        getAll,
    } = useRoles(props);

    useEffect(() => {
        const loadInitialData = async () => {
            await getAll();
            const id = props.match?.params?.id;
            if (id) {
                await getById(id);
            }
        };
        loadInitialData();
    }, [props.match?.params?.id]);

    // getAll, getById

    return <>
        <Page>
            <ToolbarComponent label={edit ? "Editar rol" : "Nuevo Rol"} showBackButton={true} onBackClick={goBack}>
                <Row padding="0 20px">
                    <br />
                    <Col md={12}>
                        <Input label="Nombre" type="text" onChange={setRolName} value={rolName} />
                    </Col>
                    <Col md={12}>
                        <PermissionManager
                            modules={modulesRole}
                            userPermissions={rolPermissions}
                            onChange={handlePermissionsChange}
                        />
                    </Col>
                    <Col md={12} className="text-right">
                        <br />
                        <PrimaryButton onClick={() => setConfirmCreate(true)} text={edit ? "Editar rol" : "Crear rol"} />
                    </Col>
                </Row>
                <ModalConfirm isOpen={confirmCreate} onClose={() => setConfirmCreate(false)} onAccept={handleSave} />
            </ToolbarComponent>
        </Page>
    </>
}

export default NewRoleView;